













































































































































































import {Utils} from '@/utils/Utils.ts';
import {Vue, Component, Watch} from 'vue-property-decorator';
import {API} from '@/services/api/api';
import VuePassword from 'vue-password';
import {mapActions, mapGetters} from 'vuex';
import {redirectTime} from '@/constants/constants';

@Component({
  components: {VuePassword},
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  computed: {...mapGetters(['roleList'])},
})
export default class CreateUser extends Vue {
  name = '';
  email = '';
  loginActiveStatus = true;
  enableStatus = false;
  password = '';
  passStrength: number = 0;
  confirmPassword = '';
  groupId: any = null;
  loadingBtnStatus = false;
  isPasswordVisible = false;
  isFormValidNow = false;
  showPass = false;
  onNullErrorMsg = 'This field is required.';
  isPasswordMatched: any = null;
  nameValidationMsg: any = null;
  emailValidationMsg: any = null;
  roleValidationMsg: any = null;
  passwordValidationMsg =
    'Password must be 8-20 characters , must include at least one: uppercase letter, lowercase letter, number & special character';

  confirmPasswordValidationMsg: any = null;
  showSuccessToast: any;
  showErrorToast: any;

  validateName() {
    if (this.name.length < 1 || this.name === '') {
      this.nameValidationMsg = this.onNullErrorMsg;
      return false;
    } else if (!Utils.validateName(this.name)) {
      this.nameValidationMsg = 'Minimum 6 characters, maximum 40 characters, only letters allowed.';
      return false;
    } else this.nameValidationMsg = null;
    return true;
  }

  validateRole() {
    if (this.groupId === null || this.groupId < 1) {
      this.roleValidationMsg = this.onNullErrorMsg;
      return false;
    } else {
      this.roleValidationMsg = null;
      return true;
    }
  }

  validateEmail() {
    if (this.email === '' || this.email === null) {
      this.emailValidationMsg = this.onNullErrorMsg;
      return false;
    } else if (!Utils.validateEmail(this.email)) {
      this.emailValidationMsg = 'E-mail is not valid.';
      return false;
    } else {
      this.emailValidationMsg = null;
      return true;
    }
  }

  validatePassword() {
    if (this.password.length < 1 || this.password === '') {
      this.passwordValidationMsg = this.onNullErrorMsg;

      return false;
    } else if (!Utils.validatePassword(this.password)) {
      this.passwordValidationMsg =
        'Password must be 8-20 characters , must include at least one: uppercase letter, lowercase letter, number & special character';
      return false;
    } else {
      this.passwordValidationMsg = '';
      return true;
    }
  }

  validateConfirmPassword() {
    if (this.confirmPassword === '' || this.confirmPassword.length < 1) {
      this.confirmPasswordValidationMsg = this.onNullErrorMsg;
      this.isPasswordMatched = false;
      return false;
    } else if (this.password !== this.confirmPassword) {
      this.confirmPasswordValidationMsg = 'Password and confirm password does not match';
      this.isPasswordMatched = false;
      return false;
    } else {
      this.confirmPasswordValidationMsg = 'Password and confirm password matched';
      this.isPasswordMatched = true;
      return true;
    }
  }

  validateAll() {
    return (
      this.validateName() &&
      this.validateRole() &&
      this.validateEmail() &&
      this.validatePassword() &&
      this.validateConfirmPassword()
    );
  }

  @Watch('password') //only 1-4 pass strength
  onPassChange(pass: string, oldPass: string) {
    this.passStrength = Utils.calculatePassStrength(pass);
  }

  //submit button handler
  async _createUserHandler() {
    if (!this.validateAll()) {
      return;
    }
    this.loadingBtnStatus = true;
    try {
      let response = await API.registerUser(
        this.name,
        this.email,
        this.loginActiveStatus,
        this.enableStatus,
        this.password,
        this.groupId
      );
      this.loadingBtnStatus = false;
      if (response.data) {
        let message: string = response.message;
        if (message.includes('User has been created')) {
          message = 'Record added successfully';
        }
        this.showSuccessToast({msg: message});
        this._formReset();
        setTimeout(() => this.$router.go(-1), redirectTime);
      } else {
        // this.showOverlay=false;
        let errorMsg = response.error;
        if (errorMsg.includes('already exists')) errorMsg = 'Email already exists.';
        this.showErrorToast({msg: errorMsg});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    }
  }

  _formReset() {
    this.name = '';
    this.email = '';
    this.password = '';
    this.groupId = null;
    this.confirmPassword = '';
  }

  togglePassword() {
    this.showPass = !this.showPass;
  }

  // @Watch("roleList",{immediate:true})
  // logger() {
  //

  // }
}
